module.exports = __webpack_public_path__ + "img/blue_142.cdb0d498.png";